<template>
  <div class="crm-filterPanel">
    <client-module
      :showTitle="false"
      :hideBorder="true"
      class="panel-card"
    >
      <filter-panel
        class="filter-panel"
        labelWidth="auto"
        :data="groups"
        @search="search"
        :simple="true"
      ></filter-panel>
      <btn-groups
        :btnList="btnList"
        class="btn-groups"
      >

        <template slot="rightBtnPrefix">
          <slot name="rightBtnPrefix"></slot>
        </template>
      </btn-groups>
    </client-module>
  </div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue'
import clientModule from '@/components/client/clientModule/clientModule'
import btnGroups from '@/components/client/clientModule/clientBtnGroups.vue'
export default {
  name: 'crm-filterPanel',
  components: {
    filterPanel,
    clientModule,
    btnGroups,
  },
  props: {
    groups: Object,
    btnList: Object,
  },
  methods: {
    search(val) {
      this.$emit('search', val)
    },
  },
}
</script>

<style lang="scss" scoped>
.panel-card {
  padding-top: 10px !important;
  background-color: #fff;
  box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
  border-radius: 4px;
  .filter-panel {
    padding-left: 26px;
  }
}
.btn-groups {
  padding: 10px 28px 5px;
}
</style>